import { Button, Drawer, Spin } from 'antd';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { TAnswerUsersInfoColumns, TGetPollResultsResponsePaginated, TQuestionInPoll } from 'shared/types/poll.types';
import { dataForAnswerUsersTable } from 'shared/helpers/utils';
import PollAnswerResultTable from 'features/tables/pollAnswerResultTable/PollAnswerResultTable';
import { TPollAnswer } from 'features/poll/questionDrawer/QuestionDrawer';
import style from './index.module.scss';

type TResultDrawerProps = {
  onClose: () => void;
  open: boolean;
  info?: TGetPollResultsResponsePaginated;
  isYourAnswer?: boolean;
  answer?: TPollAnswer;
  question?: TQuestionInPoll;
  getAnswers: (page: number, size: number, questionId: number, answerId?: number) => void;
};

const COLUMNS: TAnswerUsersInfoColumns = [
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
  },
];

const COLUMNS_OWN: TAnswerUsersInfoColumns = [
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
  },
  {
    title: 'Свой вариант',
    dataIndex: 'ownAnswer',
    key: 'ownAnswer',
  },
];

const ResultDrawer: FC<TResultDrawerProps> = ({ onClose, open, info, isYourAnswer, getAnswers, answer, question }) => {
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const DRAWER_CLOSE_BUTTON = useMemo(() => {
    return (
      <Button type="primary" onClick={onClose}>
        Закрыть
      </Button>
    );
  }, [onClose]);

  useEffect(() => {
    getAnswers(page, size, Number(question?.id), Number(answer?.id));
  }, [page, size, getAnswers, answer]);

  return (
    <Drawer
      title="Результаты опроса"
      onClose={onClose}
      open={open}
      width={700}
      closable={false}
      extra={DRAWER_CLOSE_BUTTON}
    >
      <Spin spinning={info?.data?.length === undefined}>
        <div className={style['current-variant']}>
          <p className={style['current-variant__title']}>
            Вариант:{' '}
            <span className={style['current-variant__data']}>{isYourAnswer ? 'Свой ответ' : answer?.value}</span>
          </p>
          <p className={style['current-variant__title']}>
            Количество:{' '}
            <span className={style['current-variant__data']}>
              {answer?.respondentsCount || question?.personalResponsesCount}
            </span>
          </p>
        </div>
        <PollAnswerResultTable
          dataSource={dataForAnswerUsersTable(info) || []}
          columns={isYourAnswer ? COLUMNS_OWN : COLUMNS}
          currentPage={page}
          currentSize={size}
          setCurrentPage={setPage}
          setCurrentSize={setSize}
          total={info?.pagination.total}
        />
      </Spin>
    </Drawer>
  );
};

export default ResultDrawer;
